exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tree-breadcrumb-child{display:inline-flex;color:#43454f}.tree-breadcrumb-child:first-child{margin-left:17px}.tree-breadcrumb-child:last-child{padding-right:30px;color:#3b7bff}.tree-breadcrumb-child:last-child>svg{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-02fce9a2!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/source/breadcrumb-item.vue
// module id = 316
// module chunks = 0